export const InquireText = ({ text }) => {
    if (text) {
        return (
            <p className="flex md:gap-1 flex-col md:flex-row">
                <b>{text}</b>
                <span>Always inquire directly about health and safety.</span>
            </p>
        );
    }
    
    return 'Always inquire directly about health and safety.';
};